module.exports = __webpack_public_path__ + "static/media/md-water.cd816137.svg";